import createCrudService from '@core/api/create-crud-service';
import { request } from '@src/core/api/request';
import { QUERY_KEYS } from '@src/shared/constants/query-keys';

import type { TBaseQuery } from '@src/shared/types/base-query';
import type { TStage } from '@src/shared/types/stage';
import { useMutation } from '@tanstack/react-query';
import { queryClient } from '@src/core/api/query-client';
import { showToast } from '@src/shared/utils/helpers/show-toast';

export type TStageQuery = {
  created_by?: string;
  program?: string | number;
} & TBaseQuery;

type TStagePayload = {
  name?: string;
  program?: number | string;
  description?: string;
  documents?: number[];
  media?: number | null;
};

const stageApi = {
  ...createCrudService<TStage, TStageQuery, TStagePayload>({
    queryKey: [QUERY_KEYS.getStages],
    url: `stages`,
    validateQuery: [
      'stagesList',
      QUERY_KEYS.getStagesRules,
      'completionTasks',
      QUERY_KEYS.getStagesProgress,
    ],
    factory: {
      fetch: {
        requestOptions: (params?: Partial<TStageQuery>) => ({
          params: {
            ...params,
            o: ['order'],
            page_size: 200,
          },
        }),
      },
    },
  }),
  useDuplicate: () => {
    return useMutation({
      mutationFn: ({ id }: { id: string | number }) =>
        request({
          url: `stages/${id}/duplicate/`,
          method: 'POST',
        }),
      onSuccess: () => {
        queryClient.invalidateQueries({
          predicate: (query) =>
            [QUERY_KEYS.getStages, 'stagesList'].includes(
              String(query.queryKey[0])
            ),
        });
        showToast({
          title: 'Duplicate Success',
          description: 'Stage has been duplicated successfully',
          variant: 'success',
        });
      },
    });
  },
};

export default stageApi;
